import { cn } from '@/core/utils/common'

type Props = { value: { percent: number; ready: boolean }; label: string }

/** 완성도 한 줄 — 가는 막대 + 숫자. 상태 글자는 옆의 StudioStatusBadge 한 곳에만 */
export default function CompletionMeter({ value, label }: Props) {
  return (
    <span className="flex w-full min-w-0 items-center gap-2">
      <span
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value.percent}
        aria-valuetext={`${value.percent}%, ${value.ready ? '필수 작성 완료' : '필수 항목 작성 중'}`}
        className="block h-1 min-w-0 flex-1 overflow-hidden rounded-full bg-surface-raised"
      >
        <span
          className={cn(
            'block h-full rounded-full',
            value.ready ? 'bg-ok' : 'bg-point'
          )}
          style={{ width: `${value.percent}%` }}
        />
      </span>
      <span
        aria-hidden="true"
        className="w-9 flex-none text-right text-c12 text-description tabular-nums over10:text-c14"
      >
        {value.percent}%
      </span>
    </span>
  )
}
